import { render } from "./keyBorad.vue?vue&type=template&id=6165e51e&scoped=true&ts=true"
import script from "./keyBorad.vue?vue&type=script&lang=ts"
export * from "./keyBorad.vue?vue&type=script&lang=ts"

import "./keyBorad.vue?vue&type=style&index=0&id=6165e51e&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6165e51e"]])

export default __exports__